import * as translations from './translation'
import polyglotI18nProvider from 'ra-i18n-polyglot'
import { resolveBrowserLocale } from 'react-admin'

const i18nProvider = polyglotI18nProvider(
  (locale) => (translations.default[locale] ? translations.default[locale] : translations.default['en']),
  resolveBrowserLocale(),
)

export default i18nProvider
